import { Component, OnInit, OnDestroy } from '@angular/core';
import { BehaviorSubject, map, Observable, Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { SignupService } from '../signup/signup.service';
import { VetBookerError } from '../../interfaces/vberror';
import { ParseErrorHandler } from '../../parse-error-handler';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import {
  ADDITIONAL_MATCH,
  COGNITO_VERIFICATION,
  EMAIL_VERIFICATION,
  MATCHING,
  SMS_VERIFICATION,
} from '../../../constants';
import { LoginClinicDetails } from '@appyvet/vetbooker-definitions/dist/clinic_details';
import { animate, style, transition, trigger } from '@angular/animations';
import { distinctUntilChanged, filter } from 'rxjs/operators';
@Component({
  selector: 'app-email-link-verification',
  templateUrl: './email-link-verification.component.html',
  styleUrls: ['./email-link-verification.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)' }),
        animate('200ms ease-in', style({ transform: 'translateY(0%)' })),
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateY(-100%)' })),
      ]),
    ]),
  ],
})
export class EmailLinkVerificationComponent implements OnInit, OnDestroy {
  loading$ = new BehaviorSubject<boolean>(true);
  error$ = this.signupService.error$;
  currentPage$: BehaviorSubject<string>;
  MATCHING = MATCHING;
  SMS_VERIFICATION = SMS_VERIFICATION;
  EMAIL_VERIFICATION = EMAIL_VERIFICATION;
  COGNITO_VERIFICATION = COGNITO_VERIFICATION;
  ADDITIONAL_MATCH = ADDITIONAL_MATCH;
  clinicDetails$ = new BehaviorSubject<LoginClinicDetails>(null);
  private routeSub: Subscription;
  private pageSub: Subscription;
  private verificationCodeFromUrl?: string;
  private clinicName: string;
  showInitialCard$: Observable<boolean>;
  constructor(
    private activatedRoute: ActivatedRoute,
    private signupService: SignupService,
    private gaService: GoogleAnalyticsService,
  ) {}

  ngOnInit(): void {
    this.showInitialCard$ = this.signupService.currentPage$.pipe(
      map((page) => !page),
    );

    this.currentPage$ = this.signupService.currentPage$;
    this.loading$.next(true);

    // Read and cache verification code from URL
    this.routeSub = this.activatedRoute.queryParams.subscribe((params) => {
      if (params.clientNumber) {
        return;
      }
      if (params.verificationCode) {
        this.verificationCodeFromUrl = params.verificationCode;
        this.signupService.setEmail(params.email);
        this.signupService.verifyEmailWithCode(params.verificationCode);
        this.gaService.event(
          'Register From Email Link',
          'New User Registration',
          params.clinicName || 'VetBooker',
        );
      }
    });

    this.activatedRoute.data.subscribe(
      (data: { clinicDetails: LoginClinicDetails }) => {
        this.clinicName = data.clinicDetails.clinicName;
        this.clinicDetails$.next(data.clinicDetails);
      },
    );

    // Re-trigger email verification whenever currentPage becomes EMAIL_VERIFICATION
    this.pageSub = this.signupService.currentPage$
      .pipe(
        distinctUntilChanged(),
        filter(
          (page) =>
            page === EMAIL_VERIFICATION && !!this.verificationCodeFromUrl,
        ),
      )
      .subscribe(() => {
        this.loading$.next(true);
        this.signupService.verifyEmailWithCode(this.verificationCodeFromUrl);
      });
  }

  ngOnDestroy(): void {
    this.routeSub?.unsubscribe();
    this.pageSub?.unsubscribe();
  }
}
